var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v("Eigenschappen bewerken")]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-select", {
                    attrs: {
                      fancy: "",
                      items: _vm.browseItems,
                      label: "Browse",
                    },
                    model: {
                      value: _vm.button.BrowseID,
                      callback: function ($$v) {
                        _vm.$set(_vm.button, "BrowseID", $$v)
                      },
                      expression: "button.BrowseID",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-select", {
                    attrs: {
                      fancy: "",
                      items: _vm.locationItems,
                      label: "Locatie",
                    },
                    model: {
                      value: _vm.button.Location,
                      callback: function ($$v) {
                        _vm.$set(_vm.button, "Location", $$v)
                      },
                      expression: "button.Location",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "12" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: "Icon" },
                    model: {
                      value: _vm.button.Icon,
                      callback: function ($$v) {
                        _vm.$set(_vm.button, "Icon", $$v)
                      },
                      expression: "button.Icon",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-link",
                    {
                      attrs: {
                        target: "_blank",
                        to: "https://fontawesome.com/v5/search",
                      },
                    },
                    [_vm._v("Lijst met icons")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: "Openen in modal" },
                    model: {
                      value: _vm.button.OpenInModal,
                      callback: function ($$v) {
                        _vm.$set(_vm.button, "OpenInModal", $$v)
                      },
                      expression: "button.OpenInModal",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      disabled: !_vm.button.OpenInModal,
                      label: "Gepadde modal",
                    },
                    model: {
                      value: _vm.button.PaddedModal,
                      callback: function ($$v) {
                        _vm.$set(_vm.button, "PaddedModal", $$v)
                      },
                      expression: "button.PaddedModal",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-input-number", {
                    attrs: { label: "Breedte in px", fancy: "" },
                    model: {
                      value: _vm.button.Width,
                      callback: function ($$v) {
                        _vm.$set(_vm.button, "Width", $$v)
                      },
                      expression: "button.Width",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-input-number", {
                    attrs: { label: "Hoogte in px", fancy: "" },
                    model: {
                      value: _vm.button.Height,
                      callback: function ($$v) {
                        _vm.$set(_vm.button, "Height", $$v)
                      },
                      expression: "button.Height",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v("Annuleren")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v("Opslaan")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }